import React from 'react';
import { motion } from 'framer-motion';
import { useGeoPrice } from '../hooks/useGeoPrice';
const fadeIn = {
  initial: {
    opacity: 0,
    y: 12
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-40px'
  },
  transition: {
    duration: 0.3
  }
};
export function ClosingSection() {
  const {
    price,
    loading
  } = useGeoPrice();
  const displayPrice = loading ? '$27 USD' : price;
  return <section className="w-full bg-[#0f0529] py-16 md:py-24 px-5" data-id="element-12">
      <div className="max-w-2xl mx-auto text-center" data-id="element-13">
        <motion.div {...fadeIn} data-id="element-14">
          <p className="text-lg text-gray-300 mb-6 leading-relaxed" data-id="element-15">
            No necesitas otro lunes. <br className="hidden sm:block" data-id="element-16" />
            No necesitas más motivación. <br className="hidden sm:block" data-id="element-17" />
            No necesitas ser otra persona.
          </p>
          <p className="text-xl md:text-2xl text-white font-semibold mb-8" data-id="element-18">
            Necesitas <span className="text-amber-500" data-id="element-19">5 minutos hoy</span>.
          </p>
          <p className="text-gray-400 text-sm mb-6" data-id="element-20">
            La identidad de alguien que termina se entrena.{' '}
            <br className="hidden sm:block" data-id="element-21" />
            Menos promesas, más obediencia práctica.
          </p>
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-22">
            <span className="text-gray-500 line-through text-lg" data-id="element-23">$97 USD</span>
            <span className="bg-red-500/90 text-white text-[10px] font-black uppercase px-2 py-0.5 rounded-full" data-id="element-24">
              -72% OFF
            </span>
          </div>
          <a href="https://pay.hotmart.com/R104430088E?bid=1770999394323" className="cta-hero-glow inline-flex flex-col items-center justify-center bg-amber-500 hover:bg-amber-400 text-black px-10 py-5 rounded-2xl transition-colors" data-id="element-25">
            <span className="font-black text-lg" data-id="element-26">
              OFERTA EXCLUSIVA — {displayPrice}
            </span>
            <span className="text-black/60 text-xs font-semibold mt-0.5" data-id="element-27">
              ⚡ Pronto se quitarán los bonos
            </span>
          </a>
        </motion.div>
      </div>

      {/* Footer */}
      <div className="max-w-3xl mx-auto mt-20 pt-8 border-t border-white/5 text-center" data-id="element-28">
        <p className="text-gray-600 text-xs" data-id="element-29">
          © {new Date().getFullYear()} Hábitos Atómicos Espirituales. Todos los
          derechos reservados.
        </p>
      </div>
    </section>;
}